import { render } from "./sendGoodsInfo.vue?vue&type=template&id=aded4652&scoped=true"
import script from "./sendGoodsInfo.vue?vue&type=script&lang=js"
export * from "./sendGoodsInfo.vue?vue&type=script&lang=js"

import "./sendGoodsInfo.vue?vue&type=style&index=0&id=aded4652&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aded4652"]])

export default __exports__